import { FloatingLabel, FormField, FormInputGroup, InputWithFloatingLabel, Spinner, StandardForm, TextInput } from '@vp/swan'
import { usePersonalizationManager } from '../PersonalizationManager'
import { RenderableTextField } from '../../Schemes/store/types'

interface TextEditorProps {
  textFields: RenderableTextField[]
  setTextFields: React.Dispatch<React.SetStateAction<RenderableTextField[]>>
  onTextChange: (index: number, value: string) => void
  showLoader?: boolean
}

export const TextEditor = (params: TextEditorProps) => {
  const { textFields, onTextChange, showLoader } = params
  const { translations, tracking } = usePersonalizationManager()
  const { textCopy } = translations

  return (
    <StandardForm autoComplete="off">
      {textFields.map(({ placeholder, purposeName, text, isModified }, textFieldIndex, { length }) => (
        <FormField key={purposeName}>
          <FormInputGroup mb={textFieldIndex !== length - 1 ? 'between-actions' : 0}>
            <InputWithFloatingLabel>
              <TextInput
                paddingRight={isModified ? 8 : undefined}
                placeholder={placeholder}
                value={text}
                onChange={(e): void => onTextChange(textFieldIndex, e.target.value)}
                onFocus={(): void => tracking.textFocus(purposeName)}
              />
              {showLoader && isModified && <Spinner accessibleText={textCopy.textLoading} className="personalization-text-spinner" size="tiny" />}
              <FloatingLabel>{placeholder}</FloatingLabel>
            </InputWithFloatingLabel>
          </FormInputGroup>
        </FormField>
      ))}
    </StandardForm>
  )
}
